import { Link, useLocation } from 'react-router-dom'
import { Appointment } from '$api-client/types.gen'
import { ServicesHeading } from './service'
import { Time } from './time'
import { AppointmentStatusPill } from '../../../../../components/appointment-status-pill'
import { cn } from '$components'
import { DogIcon } from '$components'
import { Profile } from './profile'
import { memo } from 'react'

export type AppointmentCardProps = {
  data: Appointment
}

export const AppointmentCard = memo(({ data }: AppointmentCardProps) => {
  const location = useLocation()

  return (
    <Link to={{ pathname: data.id.toString(), search: location.search }}>
      <div
        className={cn('p-stack-tight rounded-card-sm border flex flex-col gap-stack-tight h-full overflow-y-hidden', {
          [colourMap[data.services[0].service.colour].bg]: true,
          [colourMap[data.services[0].service.colour].border]: true,
        })}
      >
        <ServicesHeading services={data.services} />

        <Time
          start_at={data.start_at}
          finish_at={data.finish_at}
        />

        <AppointmentStatusPill
          size="sm"
          status={data.status}
        />

        <Profile
          name={data.pet.name}
          photo={data.pet.image ?? DogIcon}
        />

        <Profile
          photo={data.client.image}
          name={`${data.client.first_name} ${data.client.last_name}`}
        />
      </div>
    </Link>
  )
})

AppointmentCard.displayName = 'AppointmentCard'

const colourMap = {
  '#94a3b8': { bg: 'bg-slate-50', border: 'border-slate-300' },
  '#ea580c': { bg: 'bg-orange-50', border: 'border-orange-300' },
  '#dc2626': { bg: 'bg-danger-subtle', border: 'border-danger/40' },
  '#16a34a': { bg: 'bg-success-subtle', border: 'border-success/40' },
  '#1e3a8a': { bg: 'bg-info-subtle', border: 'border-info/40' },
  '#9333ea': { bg: 'bg-purple-50', border: 'border-purple-300' },
  '#14b8a6': { bg: 'bg-teal-50', border: 'border-teal-300' },
  '#f59e0b': { bg: 'bg-warning-subtle', border: 'border-warning/40' },
  '#3b82f6': { bg: 'bg-sky-50', border: 'border-sky-300' },
  '#10b981': { bg: 'bg-emerald-50', border: 'border-emerald-300' },
  '#f43f5e': { bg: 'bg-danger-subtle', border: 'border-danger/40' },
}
